import { render, staticRenderFns } from "./selectCus.vue?vue&type=template&id=25a42f13&scoped=true&"
import script from "./selectCus.vue?vue&type=script&lang=js&"
export * from "./selectCus.vue?vue&type=script&lang=js&"
import style0 from "./selectCus.vue?vue&type=style&index=0&id=25a42f13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a42f13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25a42f13')) {
      api.createRecord('25a42f13', component.options)
    } else {
      api.reload('25a42f13', component.options)
    }
    module.hot.accept("./selectCus.vue?vue&type=template&id=25a42f13&scoped=true&", function () {
      api.rerender('25a42f13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/personaAndCompany/personalInfo/form/components/selectCus.vue"
export default component.exports